// ============================================================================
//  "Ver como" numa aba à parte (03/11/2026)
// ============================================================================
//  O ADMIN abre o sistema como outro usuário pra tirar dúvida e corrigir o que
//  ele vê — em OUTRA aba, com a sua continuando logada como ADMIN.
//
//  O login mora no localStorage (xm_token / xm_usuario), que é o mesmo pra
//  todas as abas: trocar ali derrubava o ADMIN em todas. Na aba do "ver como"
//  essas duas chaves passam a morar no sessionStorage, que é por aba. O resto
//  do app segue lendo localStorage.getItem('xm_token') sem saber de nada.
//
//  O token chega à aba nova pelo localStorage (handoff de uso único, apagado
//  na hora) e não pela URL — URL fica no histórico e em log.
// ============================================================================

const HANDOFF = 'xm_vercomo_handoff';
const MARCA = 'xm_vercomo';
const CHAVES = { xm_token: 'xm_vercomo_token', xm_usuario: 'xm_vercomo_usuario' };
// Backup do "ver como" antigo (troca na mesma aba): aqui não se aplica.
const SEM_EFEITO = new Set(['xm_token_admin', 'xm_usuario_admin']);

let instalado = false;

export function estaEmVerComo() {
  try { return sessionStorage.getItem(MARCA) === '1'; } catch { return false; }
}

// Chamado uma vez, antes de o App montar (index.js).
export function instalarVerComo() {
  if (instalado || typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  if (params.get('ver_como') === '1') {
    try {
      const bruto = localStorage.getItem(HANDOFF);
      localStorage.removeItem(HANDOFF);
      const h = bruto ? JSON.parse(bruto) : null;
      if (h && h.token && h.usuario && Date.now() - (h.em || 0) < 2 * 60 * 1000) {
        sessionStorage.setItem(CHAVES.xm_token, h.token);
        sessionStorage.setItem(CHAVES.xm_usuario, JSON.stringify(h.usuario));
        sessionStorage.setItem(MARCA, '1');
        sessionStorage.setItem('xm_page', 'dashboard');
      }
    } catch { /* sem handoff: abre como a aba normal */ }
    window.history.replaceState(null, '', window.location.pathname);
  }
  if (!estaEmVerComo()) return;

  const proto = Object.getPrototypeOf(window.localStorage);
  const { getItem, setItem, removeItem } = proto;
  const ehLocal = (st) => st === window.localStorage;
  proto.getItem = function (k) {
    if (ehLocal(this)) {
      if (CHAVES[k]) return getItem.call(window.sessionStorage, CHAVES[k]);
      if (SEM_EFEITO.has(k)) return null;
    }
    return getItem.call(this, k);
  };
  proto.setItem = function (k, v) {
    if (ehLocal(this)) {
      if (CHAVES[k]) return setItem.call(window.sessionStorage, CHAVES[k], v);
      if (SEM_EFEITO.has(k)) return undefined;
    }
    return setItem.call(this, k, v);
  };
  proto.removeItem = function (k) {
    if (ehLocal(this) && CHAVES[k]) return removeItem.call(window.sessionStorage, CHAVES[k]);
    return removeItem.call(this, k);
  };
  instalado = true;
}

// Abre a aba nova. `obterSessao` faz o POST e devolve { token, usuario }.
// A aba abre JÁ no clique (senão o bloqueador de pop-up barra) e só depois
// recebe o endereço; se o navegador barrar mesmo assim, vira esta aba.
export async function abrirVerComo(obterSessao) {
  const aba = window.open('', '_blank');
  try {
    const { token, usuario } = await obterSessao();
    localStorage.setItem(HANDOFF, JSON.stringify({ token, usuario, em: Date.now() }));
    const destino = `${window.location.origin}/?ver_como=1`;
    if (aba) aba.location.href = destino;
    else window.location.href = destino;
  } catch (e) {
    if (aba) aba.close();
    throw e;
  }
}

// Sai do "ver como". Aba aberta pelo botão (tem opener) fecha; a que virou
// "ver como" porque o navegador barrou a aba nova volta pro login de sempre —
// fechar essa levaria junto a única aba do ADMIN.
export function sairDoVerComo() {
  try {
    Object.values(CHAVES).forEach(k => window.sessionStorage.removeItem(k));
    window.sessionStorage.removeItem(MARCA);
    window.sessionStorage.removeItem('xm_page');
  } catch { /* nada a limpar */ }
  if (window.opener) {
    window.close();
    setTimeout(() => { window.location.href = '/'; }, 150);
  } else {
    window.location.href = '/';
  }
}
